//DOC: https://docs.google.com/spreadsheets/d/1gAhYnuOqpbvQEETjeS3jD1KYMyTKyT4ZyzmiYfZQLeA/edit?gid=327123932#gid=327123932
export const AttachmentErrorMapping = {
  1: "模糊、反光",
  2: "與車主為不相同人",
  3: "資料非最新版本",
  4: "營登/變更登記表錯誤",
  5: "戶籍地址錯誤",
  6: "使用照片檔影本監理站退件",
  7: "身分證地址改制,需使用正本",
  8: "酒駕未銷案,監理站退件",
  9: "車主未滿18歲，需使用正本",
  10: "發票_車主姓名錯誤",
  11: "發票_身分證字號錯誤",
  12: "發票_補助類型錯誤",
  13: "發票_銷貨明細未出現姓名",
  14: "發票_非申請補助區域發票",
  15: "非台幣存款帳戶",
  16: "帳戶戶名與身分證不同",
  17: "帳戶號碼錯誤",
  18: "(代領牌)車主姓名錯誤",
  19: "(代領牌)戶籍地址錯誤",
  20: "(代領牌)模糊、反光",
  21: "車主姓名錯誤",
  22: "(自領牌)戶籍地址錯誤",
  23: "(自領牌)模糊、反光",
  24: "DMS預收訂金未維護",
  25: "DMS預收訂金設定錯誤",
  26: "DMS貸款核准未維護",
  27: "DMS承諾交車地點未填",
  28: "DMS承諾交車日期未填",
  29: "DMS百貨配件未維護",
  30: "車型車色錯誤",
  31: "DMS未填經銷商店別",
  32: "DMS收款資料未填入發票日期",
  33: "文件漏簽名/蓋章/漏資料",
  34: "印章姓名錯誤",
  35: "印章少檢附",
  36: "有上傳電子檔未列印出紙本",
  37: "未檢附影本紙本",
  38: "未檢附正本",
  39: "未蓋發票章/收發章",
  40: "一階未申請",
  41: "檢附自備章",
  42: "資料不符合政府規定",
  43: "沒有名額",
  44: "序號錯誤",
  45: "未檢附代辦費",
  46: "代辦費少收",
  47: "代辦費多收",
  48: "DMS未配車",
  49: "無上傳電子檔有列印出紙本",
  50: "無上傳電子檔有列印出紙本",
  51: "汰舊車主不同人，未檢附汰購文件保證書",
  52: "文件漏簽蓋章/漏資料",
  53: "分期貸款未檢附保人ID",
  54: "文件上文字未完整拍攝",
  55: "發票_開立資訊錯誤或不完全",
  56: "發票_塗改未蓋章",
  57: "發票_檢附不同車主的發票",
  58: "發票_車型錯誤",
  59: "發票_未選擇補助類型",
  60: "DMS收款資料未選擇應收寄銷款",
  61: "領牌中心選擇錯誤",
  62: "領牌完整文件未到",
  63: "自領牌及代領牌選擇錯誤",
  64: "(代領牌)電子檔提供非此訂單車主",
  65: "(代領牌)DMS領牌日期與行照不符",
  66: "系統領牌日期與行照不符",
  67: "電子檔提供非此訂單車主",
  68: "未檢附二汰車主ID",
  69: "未檢附貸款人ID",
  70: "(代領牌)未檢附一萬元發票正本",
  71: "未檢附TES發票正本",
  72: "DMS車輛發票金額與訂單系統中不符",
  73: "轉換補助類型",
  74: "(代領牌)未繳回正本",
  75: "(自領牌)未繳回正本",
  76: "一階申請資料key in 錯誤",
  77: "存摺非最新版本",
  78: "文件拍攝錯誤",
  79: "文件拍攝/上傳錯誤",
  80: "核准日期於發票開立日期之後",
  81: "經銷商未蓋正確之發票章",
  82: "經銷商未蓋正確之發票章",
  83: "發票_手開發票未拍攝收執聯",
  84: "(代領牌)手開發票未檢附收執聯正本",
  85: "手開發票未檢附收執聯正本",
  86: "經銷商DMS_銷售類別錯誤",
  87: "學生證資格不符",
  88: "提貨單資料錯誤",
  89: "無VIN碼或VIN碼不完全",
  90: "發票_非最新開立之影本",
  91: "逾期未補件",
  92: "未拍攝文件或完整文件",
  93: "通路發票影本未加蓋負責人小章",
  94: "車主姓名或授權人簽署錯誤",
  95: "文件少檢附",
  96: "自領牌領牌後未進行文件收集",
  97: "系統未壓牌照資訊",
  98: "DMS壓牌資訊錯誤",
  99: "未收到後補通報",
  100: "文件檢附錯誤",
  101: "發票_金額異常",
  102: "未檢附桃園市補助申請表",
  103: "系統牌照號碼與行照不符",
  104: "汰舊車主過世未檢附法定繼承文件",
  105: "學生證資格待確認",
  106: "發票_日期不一致",
  107: "資料送錯領牌中心",
  108: "未依SOP開立發票",
  109: "未依SOP完成自領牌作業",
  110: "合約簽署店長未簽本人中文姓名",
  111: "合約簽署業務未簽本人中文姓名",
  112: "非指定文件寄至領牌或補助中心",
  113: "文件未上傳/上傳格式不符或模糊",
  114: "補助區域或類型錯誤",
  115: "桃園補助法定代理人同意書未檢附",
  116: "授權書簽署錯誤",
  117: "通路發票未蓋正確之發票章",
  118: "帳戶委託書檢附錯誤",
}
